export const errorHandlers = controller => {
  Object.assign(controller, {
    appendSupportAlertMessage(error, target) {
      target.classList.add(...["alert", "alert-danger"]);

      const newElement = document.createElement("h4");
      const errorText = document.createTextNode(error);
      const supportText = document.createTextNode("Please try again. If problems persist, please contact support@oshcaustralia.com.au for further assistance.");

      newElement.appendChild(errorText);
      newElement.appendChild(document.createElement("br"));
      newElement.appendChild(supportText);

      target.appendChild(newElement);
    }
  });
};
